<script>
import EmailTemplate from "@/app/admin/modules/candidates/core/models/CandidatesEmailTemplateModel"
import Svc from "@/services/emailTemplatesService";
import FormErrors from '@/util/form-errors';
import CandidatesEmailTemplateValidator from "../../core/models/candidatesEmailTemplateValidator"
import errorsMixin from '@/mixins/errors.mixin';
import EmailTemplatesStoreRepo from '@/models/EmailTemplatesStoreRepo';

export default {
  render() {
    return this.$scopedSlots.default({
      list: this.list,
      listLoading: this.listLoading,
      editedTemplate: this.editedTemplate,
      loadData: this.loadData,
      loadTemplateData: this.loadTemplateData,
      loadCreateTemplate: this.loadCreateTemplate,
      sendEmail: this.sendEmail,
      post: this.post,
      update: this.update,
      remove: this.remove,
      formErrors: this.formErrors,
      processing: this.processing,
      toggleProcessing: this.toggleProcessing
    })
  },

  inject: {
    parentSvc: 'svc'
  },

  mixins: [errorsMixin],

  data: () => ({
    svc: new Svc(new EmailTemplatesStoreRepo()),
    list: [],
    listLoading: false,
    editedTemplate: new EmailTemplate(),
    formErrors: new FormErrors(),
    templateValidator: new CandidatesEmailTemplateValidator(),
    processing: false,
    templateTooltip: false
  }),

  mounted() {
    // this.loadData()
  },

  methods: {
    async loadData(params = {cache: false}) {
      this.listLoading = true
      const [list, customList] = await Promise.all([
        this.loadList({cache:params.cache}),
        this.loadCustomList({cache: params.cache})
      ])

      this.list = [...list, ...customList]
      this.listLoading = false
      this.$emit('loaded')
    },

    async loadList(params = {cache: false}) {
      try {
        let res = await this.svc.list(params)
        return res
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_CRM})
      }
    },

    async loadCustomList(params = {cache: false}) {
      try {
        let res = await this.svc.listCustom(params)
        return res
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_CRM})
      }
    },

    loadTemplateData(item) {
      this.editedTemplate = item
    },

    loadCreateTemplate() {
      this.editedTemplate = new EmailTemplate()
    },

    toggleProcessing() {
      this.processing = !this.processing
    },

    async post(data) {
      try {
        if(!this.templateValidator.validate(this.formErrors, data)) {
          this.$notify({text: 'Invalid fields', type: 'error'})
          return
        }
        this.processing = true
        await this.svc.post(data)
        this.$notify({text: 'Template created', type: 'success'})
        await this.loadData();
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_CRM,
          formErrors: this.formErrors, 
          apiAttributes: this.templateValidator.apiAttributes,
        });
        this.$notify({text: 'Sending error', type: 'error'})
      }
      finally {
        this.processing = false
      }
    },

    async update(data) {
      try {
        if(!this.templateValidator.validate(this.formErrors, data)) {
          this.$notify({text: 'Invalid fields', type: 'error'})
          return
        }
        this.processing = true
        let res = await this.svc.put(data.ID, data)
        this.$notify({text: 'Template updated', type: 'success'})
        await this.loadData();
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_CRM,
          formErrors: this.formErrors, 
          apiAttributes: this.templateValidator.apiAttributes,
        });
        this.$notify({text: 'Sending error', type: 'error'})
      }
      finally {
        this.processing = false
      }
    },

    async remove(data) {
      try {
        this.processing = true
        await this.svc.remove(data.ID)
        this.$notify({text: 'Template removed', type: 'success'})
        await this.loadData();
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_CRM,
          formErrors: this.formErrors, 
          apiAttributes: this.templateValidator.apiAttributes,
        });
        this.$notify({text: 'Sending error', type: 'error'})
      }
      finally {
        this.processing = false
      }
    },
  },
}
</script>